var map = {
	"./decidim/avatar-multiuser.png": 66355,
	"./decidim/brands/facebook.svg": 6971,
	"./decidim/brands/google.svg": 99986,
	"./decidim/brands/twitter-x.svg": 63091,
	"./decidim/cc-badge.png": 35441,
	"./decidim/decidim-logo.svg": 55905,
	"./decidim/default-avatar.svg": 34529,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 8407,
	"./decidim/icons.svg": 93760,
	"./decidim/pattern.png": 92547,
	"./decidim/placeholder-card-g.svg": 40896,
	"./decidim/placeholder-card-l.svg": 54635,
	"./decidim/placeholder.jpg": 45858,
	"./decidim/remixicon.symbol.svg": 94136,
	"./decidim/vendor/social-share-button/douban.svg": 85131,
	"./decidim/vendor/social-share-button/email.svg": 27844,
	"./decidim/vendor/social-share-button/facebook.svg": 38368,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 91924,
	"./decidim/vendor/social-share-button/hacker_news.svg": 79560,
	"./decidim/vendor/social-share-button/linkedin.svg": 83970,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 38379,
	"./decidim/vendor/social-share-button/pinterest.svg": 21410,
	"./decidim/vendor/social-share-button/reddit.svg": 71864,
	"./decidim/vendor/social-share-button/telegram.svg": 64077,
	"./decidim/vendor/social-share-button/tumblr.svg": 9130,
	"./decidim/vendor/social-share-button/twitter.svg": 10529,
	"./decidim/vendor/social-share-button/vkontakte.svg": 96811,
	"./decidim/vendor/social-share-button/wechat.svg": 34230,
	"./decidim/vendor/social-share-button/whatsapp.svg": 21646,
	"./decidim/vendor/social-share-button/x.svg": 74236,
	"./decidim/vendor/social-share-button/xing.svg": 61372
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44316;